import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "mdbreact/dist/css/mdb.css";
import {
  MDBCarousel,
  MDBCarouselCaption,
  MDBCarouselInner,
  MDBCarouselItem,
  MDBView,
} from "mdbreact";
import carouselItems from "../Helpers/carousel-data";

class Slider extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    let carousel = carouselItems.items.map((item, key) => {
      return (
        <MDBCarouselItem itemId={item.id} key={key}>
          {/* <MDBView>
                    <div style={{height:"250px", backgroundColor:"#1d39c4"}}></div>
                    <img className="d-block w-100" src="https://mdbootstrap.com/img/Photos/Slides/img%20(68).jpg" alt="First slide" />
                    <MDBMask overlay="black-light" />
                    </MDBView> */}
          <MDBView>
            <img src={item.img} alt="" className="d-block w-100" />
          </MDBView>
          <MDBCarouselCaption>
            <h3 className="h3-responsive">{item.caption}</h3>
            <p>{item.description}</p>
          </MDBCarouselCaption>
        </MDBCarouselItem>
      );
    });

    return (
      <div style={{ padding: "10px" }}>
        <MDBCarousel
          activeItem={1}
          length={carouselItems.items.length}
          showControls={true}
          showIndicators={true}
          className="z-depth-1"
        >
          <MDBCarouselInner>{carousel}</MDBCarouselInner>
        </MDBCarousel>
      </div>
    );
  }
}

export default Slider;
